import { useEventParticipantsList } from './useEventParticipantsList';

/**
 * Same as useEventParticipantList but only returns one
 * @param {Number}      eventId             Event ID
 * @param {object}      participantQuery    Query to match to the participants {userId, participantId} (at least one has to match)
 * @param {Function}    filter              Filter function
 * @param {Number}      questionId          Question to include asker+answeres in the search
 * @param {Number}      directoryItemId     Directory item to include 'contacts' in the search
 * @param {Number}      sessionId           Session to include assignees in the search (for tasks)
 * @returns Participant
 */

export function useEventParticipant(eventId, participantQuery, { filter, questionId, directoryItemId, sessionId } = {}) {
    return useEventParticipantsList(eventId, [participantQuery], { filter, questionId, directoryItemId , sessionId})?.[0];
}
